// extracted by mini-css-extract-plugin
export default {"wrapper":"TD-z","viewport":"UD-z","container":"VD-z","slide":"WD-z"};